export const ordersReceived = orders => ({
    type: 'ORDERS_RECEIVED',
    payload: orders
});

